import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    breakpoint: null
  },
  mutations: {
    setBreakpoint(state, breakpoint) {
      state.breakpoint = breakpoint
    }
  },
  actions: {
  },
  modules: {
  }
})
